import { all, takeEvery, put, call } from 'redux-saga/effects'
import * as Services from 'services/transaction'
import * as Notification from 'services/showNotifications'
import actions from './actions'

export function* FETCH_AGENT_PAYMENTS({ payload: { agentId, queryParams } }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: { agentPayments: { loading: true } },
    })

    const response = yield call(Services.fetchAgentPayments, { agentId, queryParams })

    if (response && !response.error) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          agentPayments: {
            loading: false,
            data: response.data,
          },
        },
      })
    } else {
      throw new Error(response?.message || 'Failed to fetch payments')
    }
  } catch (err) {
    yield put({
      type: actions.SET_STATE,
      payload: { agentPayments: { loading: false } },
    })
    Notification.showError(err.message)
  }
}

export function* FETCH_AGENT_PAYMENT_DETAILS({ payload: { agentId, paymentId } }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: { agentPayment: { loading: true } },
    })

    const response = yield call(Services.fetchAgentPaymentDetails, { agentId, paymentId })

    if (response && !response.error) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          agentPayment: {
            loading: false,
            data: response.data,
          },
        },
      })
    } else {
      throw new Error(response?.message || 'Failed to fetch payment details')
    }
  } catch (err) {
    yield put({
      type: actions.SET_STATE,
      payload: { agentPayment: { loading: false } },
    })
    Notification.showError(err.message)
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_AGENT_PAYMENTS, FETCH_AGENT_PAYMENTS),
    takeEvery(actions.FETCH_AGENT_PAYMENT_DETAILS, FETCH_AGENT_PAYMENT_DETAILS),
  ])
}
